import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router';

import { useFeature } from '@treams/treams-hooks';
import { AddIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Button, Jumbo } from '@treams/treams-ui';

import OutgoingConversationsList from './OutgoingConversationsList';
import UserConversationTabs from './UserConversationTabs';

export default function UserOutgoingConversations() {
	const { t } = useTranslation();
	const isAdhocEnabled = useFeature(graphql.FeatureName.EvaluationsAdhoc);

	const { params } = useRouteMatch<{ id: string }>();
	const { id: userID } = params;

	const query = graphql.useOutgoingEvaluationSubmissionsQuery({
		variables: { userID, isArchived: false, last: 5 },
	});

	const [fetchArchived, archivedQuery] = graphql.useOutgoingEvaluationSubmissionsLazyQuery({
		variables: { userID, isArchived: true, last: 5 },
	});

	const userQuery = graphql.useUserQuery({ variables: { id: userID } });

	return (
		<>
			<Jumbo
				title={t('user.conversations.outgoing.title', {
					name: userQuery.data?.user.firstName,
				})}
				button={
					isAdhocEnabled && (
						<Button
							icon={<AddIcon />}
							title={t('user.conversations.index.new', {
								name: userQuery.data?.user.firstName,
							})}
							link={`/users/${userID}/conversations/create`}
						/>
					)
				}
				footer={<UserConversationTabs user={userQuery.data?.user as graphql.User} />}
			/>

			<OutgoingConversationsList
				query={query}
				archivedQuery={archivedQuery}
				fetchArchived={fetchArchived}
			/>
		</>
	);
}
